/*global DSV, jQuery */

/** 
 * DSV selfService
 */

(function ($, window) {
    "use strict";

    DSV.selfService = {
        tooltip: function ($selfService) {
            var $selfServiceLines = $selfService.find("li");
            var $selfServiceLinks = $selfService.find("a");

            for (var i = 0; i < $selfServiceLines.length; i++) {
                if ($selfServiceLinks[i].title && Modernizr.touchevents) {
                    $($selfServiceLines[i]).find(".active").on("click", { className: "active-click" }, DSV.ui.toggle.switchClass)
                }
            }

        }
    };

})(jQuery, window);